import { useState, ReactNode, Fragment } from 'react'
import { Box, Popover, Typography } from '@mui/material'

export interface PopoverTooltipProps {
  children: ReactNode
  content: ReactNode
}

export const PopoverTooltip = ({ children, content }: PopoverTooltipProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <Fragment>
      <Box component="span" onClick={handleClick} sx={{ display: 'inline-flex', cursor: 'pointer' }}>
        {children}
      </Box>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        slotProps={{
          paper: {
            sx: { maxWidth: 250 },
          },
        }}
      >
        <Box p={1.5}>{typeof content === 'string' ? <Typography variant="body2">{content}</Typography> : content}</Box>
      </Popover>
    </Fragment>
  )
}
